import classNames from 'classnames';

import ArticleCard from '../ArticleCard';
import CustomSectionHeader from '../CustomSectionHeader';
import EditorialCard from '../EditorialCard';
import SnippetEditorial from '../SnippetEditorial';

import type { BaseArticleProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ArticleCardProps';
import type { CardSetProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CardSetProps';
import type { EditorialCardProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/EditorialCardProps';
import type { SnippetEditorialProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/SnippetEditorialProps';

import STYLES from './CardSet.module.scss';

const CardSet = ({ header, items, subheader, type }: CardSetProps) => {
  const containerStyle =
    type === 'CARD_TYPE_SNIPPET_EDITORIAL' ? 'rows' : 'columns';

  return (
    <div className={STYLES.CardSet}>
      <CustomSectionHeader header={header} subheader={subheader} />

      <div
        className={classNames([
          STYLES.CardContainer,
          [STYLES[`CardContainer--${containerStyle}`]],
          {
            [STYLES[`CardContainer--with-margin-top`]]: header || subheader,
          },
        ])}
      >
        {items.map((item) => {
          if (type === 'CARD_TYPE_SNIPPET_EDITORIAL') {
            const snippetEditorialItem = item as SnippetEditorialProps;

            return (
              <SnippetEditorial
                key={snippetEditorialItem.id}
                {...snippetEditorialItem}
              />
            );
          }

          if (type === 'CARD_TYPE_EDITORIAL_ARTICLE') {
            const articleItem = item as BaseArticleProps;

            return (
              <ArticleCard
                key={articleItem.articleHref}
                {...articleItem}
                variant="cardSet"
                aspectRatio={1.5}
              />
            );
          }

          const editorialItem = item as EditorialCardProps;

          return <EditorialCard key={editorialItem.href} {...editorialItem} />;
        })}
      </div>
    </div>
  );
};

export default CardSet;
